import { render, staticRenderFns } from "./VQLong.vue?vue&type=template&id=20bb1462&scoped=true&"
import script from "./VQLong.vue?vue&type=script&lang=js&"
export * from "./VQLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb1462",
  null
  
)

export default component.exports